// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsEnum, IsInt, IsNotEmpty, IsOptional, IsBoolean, IsString, ValidateNested, Min, Max } from 'class-validator';
import { Civil3dFeatureType, civil3dFeatureTypesByCategory } from '../../../../../types/constants/civil3d-feature-type';

export class LayerForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class SymbolForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class LineweightForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  weight: number;
}

export class ColorBookForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class PlotStyleForm {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

export class AutodeskLayerForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  description: string | null;

  @IsNotEmpty()
  @IsString()
  color: string;

  @IsBoolean()
  isPlot: boolean;

  @IsBoolean()
  isNewViewportFreeze: boolean;

  @IsInt()
  @Min(0)
  @Max(90)
  transparency: number;

  @ValidateNested()
  layer: LayerForm;

  @ValidateNested()
  symbol: SymbolForm;

  @ValidateNested()
  lineweight: LineweightForm;

  @ValidateNested()
  colorBook: ColorBookForm;

  @ValidateNested()
  template: TemplateForm;

  @IsOptional()
  @ValidateNested()
  plotStyle: PlotStyleForm | null;
}

export class LineStyleForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class FeatureClassForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class ConfigurationForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class FeatureLineForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  query: string;

  @IsInt()
  priority: number;

  @IsOptional()
  @IsString()
  propertyMappings?: string;

  @IsEnum(civil3dFeatureTypesByCategory[Civil3dFeatureType.FEATURE_LINE])
  civil3dFeatureType: Civil3dFeatureType;

  @ValidateNested()
  featureClass: FeatureClassForm;

  @IsOptional()
  @ValidateNested()
  lineStyle?: LineStyleForm;

  @IsOptional()
  @ValidateNested()
  autodeskLayer?: AutodeskLayerForm;

  @ValidateNested()
  configuration: ConfigurationForm;
}
